/**
 * Whether a string is a path inside this site, and nowhere else.
 *
 * `value.startsWith('/')` looks like it answers that and does not. A
 * protocol-relative URL — `//evil.example` — starts with a slash and is
 * somebody else's origin; browsers resolve it against the current scheme and
 * go. A backslash is worse, because several browsers normalise `/\evil.example`
 * to the same thing.
 *
 * Two places in this app were deciding with the naive check. One sent people
 * after sign-in to wherever `?next=` pointed, which turns a genuine
 * quantifyrapp.com link into a phishing hop — the domain in the address bar is
 * real, which is exactly what makes it work. The other decided which requests
 * carry the session token as a header, so a crafted URL could have posted it
 * to another origin.
 */
export function isInternalPath(value: string | null | undefined): boolean {
  if (!value) return false;
  // A single leading slash, and the next character must not open an authority.
  return /^\/(?![/\\])/.test(value);
}

/** The path if it is safely internal, otherwise the fallback. */
export function internalPathOr(value: string | null | undefined, fallback = '/dashboard'): string {
  return isInternalPath(value) ? (value as string) : fallback;
}
